export default __webpack_public_path__ + "static/49aa-48d25d81b54ddbe40c9ce23a2be6bcc0.png";